import { ProductData } from "@/types/config.types";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { TrashIcon } from "../Icons/TrashIcon";
import Button from "../UI/Button";
import styles from "./PrescriptionTitle.module.css";

export const PrescriptionTitle: FC<{
  product: ProductData | null;
  disableRemove?: boolean;
  handleRemoveProduct?: (lens: "OD" | "OS") => void;
  eye?: "OS" | "OD";
}> = ({ product, disableRemove = false, handleRemoveProduct, eye }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <img
          className={styles.productImage}
          src={product?.description[0]?.thumbnail || ""}
          alt={product?.description[0]?.name || ""}
        />
        <h3 className={styles.productTitle}>
          {product?.description[0]?.model}
        </h3>
      </div>
      {!disableRemove && (
        <Button
          onClick={() => {
            handleRemoveProduct && eye && handleRemoveProduct(eye);
          }}
          variant="link"
          icon={<TrashIcon color="text" size={24} />}
        >
          {t("steps.advancedPrescription.removeProduct")}
        </Button>
      )}
      <h3 className={styles.productTitleMobile}>
        {product?.description[0]?.model}
      </h3>
    </div>
  );
};

export default PrescriptionTitle;
